<template>
    <ion-app id="app">
        <ion-content>
            <Menu></Menu>
            <router-view/>
            <br><br>
        </ion-content>
    </ion-app>
</template>

<script>

import Menu from '@/components/Menu';
import {userdetails} from '@/mixins/userdetails';
export default {
    mixins : [userdetails],
    components : {
        Menu
    }
}
</script>

<style lang="scss">
@import "./sass/app.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #495b64;
}

.logo {
  margin : 50px auto;
}
.white-input {
    --background: var(--ion-color-light);
    --color: var(--ion-color-dark);
}
</style>
